require('./opal');

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/arithmetic/node"] = function(Opal) {
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send2 = Opal.send2;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'Arithmetic');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'Node');

        var $nesting = [self].concat($parent_nesting);

        
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'BinaryOp');

          var $nesting = [self].concat($parent_nesting), $BinaryOp_initialize$1, $BinaryOp_eval$2, $BinaryOp_output$3, $BinaryOp_s_exp$4, $BinaryOp_op_for_s_exp$5;

          self.$$prototype.lhs = self.$$prototype.rhs = self.$$prototype.op = nil;
          
          
          Opal.def(self, '$initialize', $BinaryOp_initialize$1 = function $$initialize(lhs, op, rhs) {
            var self = this;

            
            self.lhs = lhs;
            self.op = op;
            return (self.rhs = rhs);
          }, $BinaryOp_initialize$1.$$arity = 3);
          
          Opal.def(self, '$eval', $BinaryOp_eval$2 = function(round_type) {
            var self = this, l = nil, r = nil;

            
            l = self.lhs.$eval(round_type);
            r = self.rhs.$eval(round_type);
            return l.$send(self.op, r);
          }, $BinaryOp_eval$2.$$arity = 1);
          
          Opal.def(self, '$output', $BinaryOp_output$3 = function $$output() {
            var self = this;

            return "" + (self.lhs.$output()) + (self.op) + (self.rhs.$output())
          }, $BinaryOp_output$3.$$arity = 0);
          
          Opal.def(self, '$s_exp', $BinaryOp_s_exp$4 = function $$s_exp() {
            var self = this;

            return "" + "(" + (self.$op_for_s_exp()) + " " + (self.lhs.$s_exp()) + " " + (self.rhs.$s_exp()) + ")"
          }, $BinaryOp_s_exp$4.$$arity = 0);
          return (Opal.def(self, '$op_for_s_exp', $BinaryOp_op_for_s_exp$5 = function $$op_for_s_exp() {
            var self = this;

            return self.op
          }, $BinaryOp_op_for_s_exp$5.$$arity = 0), nil) && 'op_for_s_exp';
        })($nesting[0], null, $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideBase');

          var $nesting = [self].concat($parent_nesting), $DivideBase_initialize$6, $DivideBase_eval$7, $DivideBase_output$8, $DivideBase_rounding_method$9, $DivideBase_op_for_s_exp$10, $DivideBase_divide_and_round$11;

          self.$$prototype.lhs = self.$$prototype.rhs = self.$$prototype.op = nil;
          
          
          Opal.def(self, '$initialize', $DivideBase_initialize$6 = function $$initialize(lhs, rhs) {
            var $iter = $DivideBase_initialize$6.$$p, $yield = $iter || nil, self = this;

            if ($iter) $DivideBase_initialize$6.$$p = null;
            return $send2(self, Opal.find_super_dispatcher(self, 'initialize', $DivideBase_initialize$6, false, true), 'initialize', [lhs, "/", rhs], null)
          }, $DivideBase_initialize$6.$$arity = 2);
          
          Opal.def(self, '$eval', $DivideBase_eval$7 = function(round_type) {
            var self = this, l = nil, r = nil;

            
            l = self.lhs.$eval(round_type);
            r = self.rhs.$eval(round_type);
            if (r['$=='](0)) {
              self.$raise($$($nesting, 'ZeroDivisionError'))};
            return self.$divide_and_round(l, r, round_type);
          }, $DivideBase_eval$7.$$arity = 1);
          
          Opal.def(self, '$output', $DivideBase_output$8 = function $$output() {
            var $iter = $DivideBase_output$8.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

            if ($iter) $DivideBase_output$8.$$p = null;
            // Prepare super implicit arguments
            for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
              $zuper[$zuper_i] = arguments[$zuper_i];
            }
            return "" + ($send2(self, Opal.find_super_dispatcher(self, 'output', $DivideBase_output$8, false, true), 'output', $zuper, $iter)) + (self.$rounding_method())
          }, $DivideBase_output$8.$$arity = 0);
          self.$private();
          
          Opal.def(self, '$rounding_method', $DivideBase_rounding_method$9 = function $$rounding_method() {
            var self = this;

            return $$$(self.$class(), 'ROUNDING_METHOD')
          }, $DivideBase_rounding_method$9.$$arity = 0);
          
          Opal.def(self, '$op_for_s_exp', $DivideBase_op_for_s_exp$10 = function $$op_for_s_exp() {
            var self = this;

            return "" + (self.op) + (self.$rounding_method())
          }, $DivideBase_op_for_s_exp$10.$$arity = 0);
          return (Opal.def(self, '$divide_and_round', $DivideBase_divide_and_round$11 = function $$divide_and_round(_dividend, _divisor, _round_type) {
            var self = this;

            return self.$raise($$($nesting, 'NotImplementedError'))
          }, $DivideBase_divide_and_round$11.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'BinaryOp'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideWithGameSystemDefault');

          var $nesting = [self].concat($parent_nesting), $DivideWithGameSystemDefault_divide_and_round$12;

          
          Opal.const_set($nesting[0], 'ROUNDING_METHOD', "");
          self.$private();
          return (Opal.def(self, '$divide_and_round', $DivideWithGameSystemDefault_divide_and_round$12 = function $$divide_and_round(dividend, divisor, round_type) {
            var self = this, $case = nil;

            return (function() {$case = round_type;
            if ($$$($$($nesting, 'RoundType'), 'CEIL')['$===']($case)) {return $rb_divide(dividend.$to_f(), divisor).$ceil()}
            else if ($$$($$($nesting, 'RoundType'), 'ROUND')['$===']($case)) {return $rb_divide(dividend.$to_f(), divisor).$round()}
            else {return $rb_divide(dividend, divisor).$to_i()}})()
          }, $DivideWithGameSystemDefault_divide_and_round$12.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideWithCeil');

          var $nesting = [self].concat($parent_nesting), $DivideWithCeil_divide_and_round$13;

          
          Opal.const_set($nesting[0], 'ROUNDING_METHOD', "C");
          self.$private();
          return (Opal.def(self, '$divide_and_round', $DivideWithCeil_divide_and_round$13 = function $$divide_and_round(dividend, divisor, _round_type) {
            var self = this;

            return $rb_divide(dividend.$to_f(), divisor).$ceil()
          }, $DivideWithCeil_divide_and_round$13.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideWithRound');

          var $nesting = [self].concat($parent_nesting), $DivideWithRound_divide_and_round$14;

          
          Opal.const_set($nesting[0], 'ROUNDING_METHOD', "R");
          self.$private();
          return (Opal.def(self, '$divide_and_round', $DivideWithRound_divide_and_round$14 = function $$divide_and_round(dividend, divisor, _round_type) {
            var self = this;

            return $rb_divide(dividend.$to_f(), divisor).$round()
          }, $DivideWithRound_divide_and_round$14.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideWithFloor');

          var $nesting = [self].concat($parent_nesting), $DivideWithFloor_divide_and_round$15;

          
          Opal.const_set($nesting[0], 'ROUNDING_METHOD', "F");
          self.$private();
          return (Opal.def(self, '$divide_and_round', $DivideWithFloor_divide_and_round$15 = function $$divide_and_round(dividend, divisor, _round_type) {
            var self = this;

            return $rb_divide(dividend, divisor).$to_i()
          }, $DivideWithFloor_divide_and_round$15.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Negative');

          var $nesting = [self].concat($parent_nesting), $Negative_initialize$16, $Negative_eval$17, $Negative_output$18, $Negative_s_exp$19;

          self.$$prototype.body = nil;
          
          
          Opal.def(self, '$initialize', $Negative_initialize$16 = function $$initialize(body) {
            var self = this;

            return (self.body = body)
          }, $Negative_initialize$16.$$arity = 1);
          
          Opal.def(self, '$eval', $Negative_eval$17 = function(round_type) {
            var self = this;

            return self.body.$eval(round_type)['$-@']()
          }, $Negative_eval$17.$$arity = 1);
          
          Opal.def(self, '$output', $Negative_output$18 = function $$output() {
            var self = this;

            return "" + "-" + (self.body.$output())
          }, $Negative_output$18.$$arity = 0);
          return (Opal.def(self, '$s_exp', $Negative_s_exp$19 = function $$s_exp() {
            var self = this;

            return "" + "(- " + (self.body.$s_exp()) + ")"
          }, $Negative_s_exp$19.$$arity = 0), nil) && 's_exp';
        })($nesting[0], null, $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Parenthesis');

          var $nesting = [self].concat($parent_nesting), $Parenthesis_initialize$20, $Parenthesis_eval$21, $Parenthesis_output$22, $Parenthesis_s_exp$23;

          self.$$prototype.expr = nil;
          
          
          Opal.def(self, '$initialize', $Parenthesis_initialize$20 = function $$initialize(expr) {
            var self = this;

            return (self.expr = expr)
          }, $Parenthesis_initialize$20.$$arity = 1);
          
          Opal.def(self, '$eval', $Parenthesis_eval$21 = function(round_type) {
            var self = this;

            return self.expr.$eval(round_type)
          }, $Parenthesis_eval$21.$$arity = 1);
          
          Opal.def(self, '$output', $Parenthesis_output$22 = function $$output() {
            var self = this;

            return "" + "(" + (self.expr.$output()) + ")"
          }, $Parenthesis_output$22.$$arity = 0);
          return (Opal.def(self, '$s_exp', $Parenthesis_s_exp$23 = function $$s_exp() {
            var self = this;

            return "" + "(Parenthesis " + (self.expr.$s_exp()) + ")"
          }, $Parenthesis_s_exp$23.$$arity = 0), nil) && 's_exp';
        })($nesting[0], null, $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Number');

          var $nesting = [self].concat($parent_nesting), $Number_initialize$24, $Number_eval$25, $Number_output$26;

          self.$$prototype.value = nil;
          
          
          Opal.def(self, '$initialize', $Number_initialize$24 = function $$initialize(value) {
            var self = this;

            return (self.value = value)
          }, $Number_initialize$24.$$arity = 1);
          
          Opal.def(self, '$eval', $Number_eval$25 = function(_round_type) {
            var self = this;

            return self.value
          }, $Number_eval$25.$$arity = 1);
          
          Opal.def(self, '$output', $Number_output$26 = function $$output() {
            var self = this;

            return self.value.$to_s()
          }, $Number_output$26.$$arity = 0);
          return Opal.alias(self, "s_exp", "output");
        })($nesting[0], null, $nesting);
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["racc/parser"] = function(Opal) {
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  var $a, self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $truthy = Opal.truthy, $gvars = Opal.gvars, $send = Opal.send;

  
  (function($base, $parent_nesting) {
    var self = $module($base, 'Racc');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $super, $parent_nesting) {
      var self = $klass($base, $super, 'ParseError');

      var $nesting = [self].concat($parent_nesting);

      return nil
    })($nesting[0], $$($nesting, 'StandardError'), $nesting)
  })($nesting[0], $nesting);
  if ($truthy((($a = $$$('::', 'ParseError', 'skip_raise')) ? 'constant' : nil))) {
  } else {
    Opal.const_set($nesting[0], 'ParseError', $$$($$($nesting, 'Racc'), 'ParseError'))
  };
  return (function($base, $parent_nesting) {
    var self = $module($base, 'Racc');

    var $nesting = [self].concat($parent_nesting), $a;

    
    if ($truthy((($a = $$($nesting, 'Racc_No_Extensions', 'skip_raise')) ? 'constant' : nil))) {
    } else {
      Opal.const_set($nesting[0], 'Racc_No_Extensions', false)
    };
    (function($base, $super, $parent_nesting) {
      var self = $klass($base, $super, 'Parser');

      var $nesting = [self].concat($parent_nesting), $Parser_racc_runtime_type$1, $Parser__racc_setup$2, $Parser__racc_init_sysvars$3, $Parser_do_parse$4, $Parser_next_token$5, $Parser__racc_do_parse_rb$6, $Parser_yyparse$8, $Parser__racc_yyparse_rb$9, $Parser__racc_evalact$12, $Parser__racc_do_reduce$14, $Parser_on_error$15, $Parser_yyerror$16, $Parser_yyaccept$17, $Parser_yyerrok$18, $Parser_racc_read_token$19, $Parser_racc_shift$20, $Parser_racc_reduce$21, $Parser_racc_accept$23, $Parser_racc_e_pop$24, $Parser_racc_next_state$25, $Parser_racc_print_stacks$26, $Parser_racc_print_states$28, $Parser_racc_token2str$30, $Parser_token_to_str$31;

      self.$$prototype.yydebug = self.$$prototype.racc_debug_out = self.$$prototype.racc_error_status = self.$$prototype.racc_t = self.$$prototype.racc_vstack = self.$$prototype.racc_val = self.$$prototype.racc_state = self.$$prototype.racc_tstack = nil;
      
      Opal.const_set($nesting[0], 'Racc_Runtime_Version', "1.4.6");
      Opal.const_set($nesting[0], 'Racc_Runtime_Revision', ["originalRevision:", "1.8"]['$[]'](1));
      Opal.const_set($nesting[0], 'Racc_Runtime_Core_Version_R', "1.4.6");
      Opal.const_set($nesting[0], 'Racc_Runtime_Core_Revision_R', ["originalRevision:", "1.8"]['$[]'](1));
      Opal.const_set($nesting[0], 'Racc_Main_Parsing_Routine', "_racc_do_parse_rb");
      Opal.const_set($nesting[0], 'Racc_YY_Parse_Method', "_racc_yyparse_rb");
      Opal.const_set($nesting[0], 'Racc_Runtime_Core_Version', $$($nesting, 'Racc_Runtime_Core_Version_R'));
      Opal.const_set($nesting[0], 'Racc_Runtime_Core_Revision', $$($nesting, 'Racc_Runtime_Core_Revision_R'));
      Opal.const_set($nesting[0], 'Racc_Runtime_Type', "ruby");
      Opal.defs($$($nesting, 'Parser'), '$racc_runtime_type', $Parser_racc_runtime_type$1 = function $$racc_runtime_type() {
        var self = this;

        return $$($nesting, 'Racc_Runtime_Type')
      }, $Parser_racc_runtime_type$1.$$arity = 0);
      
      Opal.def(self, '$_racc_setup', $Parser__racc_setup$2 = function $$_racc_setup() {
        var $a, $b, self = this, $ret_or_1 = nil, arg = nil, $writer = nil;
        if ($gvars.stderr == null) $gvars.stderr = nil;

        
        if ($truthy($$$(self.$class(), 'Racc_debug_parser'))) {
        } else {
          self.yydebug = false
        };
        if ($truthy((($a = self['yydebug'], $a != null && $a !== nil) ? 'instance-variable' : nil))) {
        } else {
          self.yydebug = false
        };
        if ($truthy(self.yydebug)) {
          
          if ($truthy((($b = self['racc_debug_out'], $b != null && $b !== nil) ? 'instance-variable' : nil))) {
          } else {
            self.racc_debug_out = $gvars.stderr
          };
          self.racc_debug_out = (function() {if ($truthy(($ret_or_1 = self.racc_debug_out))) {
            return $ret_or_1
          } else {
            return $gvars.stderr
          }; return nil; })();};
        arg = $$$(self.$class(), 'Racc_arg');
        if ($truthy($rb_lt(arg.$size(), 14))) {
          
          $writer = [13, true];
          $send(arg, '[]=', Opal.to_a($writer));
          $writer[$rb_minus($writer["length"], 1)];};
        return arg;
      }, $Parser__racc_setup$2.$$arity = 0);
      
      Opal.def(self, '$_racc_init_sysvars', $Parser__racc_init_sysvars$3 = function $$_racc_init_sysvars() {
        var self = this;

        
        self.racc_state = [0];
        self.racc_tstack = [];
        self.racc_vstack = [];
        self.racc_t = nil;
        self.racc_val = nil;
        self.racc_read_next = true;
        self.racc_user_yyerror = false;
        return (self.racc_error_status = 0);
      }, $Parser__racc_init_sysvars$3.$$arity = 0);
      
      Opal.def(self, '$do_parse', $Parser_do_parse$4 = function $$do_parse() {
        var self = this;

        return self.$__send__($$($nesting, 'Racc_Main_Parsing_Routine'), self.$_racc_setup(), false)
      }, $Parser_do_parse$4.$$arity = 0);
      
      Opal.def(self, '$next_token', $Parser_next_token$5 = function $$next_token() {
        var self = this;

        return self.$raise($$($nesting, 'NotImplementedError'), "" + (self.$class()) + "#next_token is not defined")
      }, $Parser_next_token$5.$$arity = 0);
      
      Opal.def(self, '$_racc_do_parse_rb', $Parser__racc_do_parse_rb$6 = function $$_racc_do_parse_rb(arg, in_debug) {
        var $a, $b, $$7, self = this, action_table = nil, action_check = nil, action_default = nil, action_pointer = nil, _ = nil, token_table = nil, tok = nil, act = nil, i = nil;

        
        $b = arg, $a = Opal.to_ary($b), (action_table = ($a[0] == null ? nil : $a[0])), (action_check = ($a[1] == null ? nil : $a[1])), (action_default = ($a[2] == null ? nil : $a[2])), (action_pointer = ($a[3] == null ? nil : $a[3])), (_ = ($a[4] == null ? nil : $a[4])), (_ = ($a[5] == null ? nil : $a[5])), (_ = ($a[6] == null ? nil : $a[6])), (_ = ($a[7] == null ? nil : $a[7])), (_ = ($a[8] == null ? nil : $a[8])), (_ = ($a[9] == null ? nil : $a[9])), (token_table = ($a[10] == null ? nil : $a[10])), (_ = ($a[11] == null ? nil : $a[11])), (_ = ($a[12] == null ? nil : $a[12])), (_ = ($a[13] == null ? nil : $a[13])), $b;
        self.$_racc_init_sysvars();
        tok = (act = (i = nil));
        return $send(self, 'catch', ["racc_end_parse"], ($$7 = function(){var self = $$7.$$s == null ? this : $$7.$$s, $c, $d, $e, $ret_or_2 = nil, $ret_or_3 = nil, $ret_or_4 = nil;
          if (self.racc_state == null) self.racc_state = nil;
          if (self.racc_read_next == null) self.racc_read_next = nil;
          if (self.racc_t == null) self.racc_t = nil;
          if (self.yydebug == null) self.yydebug = nil;
          if (self.racc_val == null) self.racc_val = nil;

        while ($truthy(true)) {
            
            if ($truthy((i = action_pointer['$[]'](self.racc_state['$[]'](-1))))) {
              
              if ($truthy(self.racc_read_next)) {
                if ($truthy(self.racc_t['$!='](0))) {
                  
                  $e = self.$next_token(), $d = Opal.to_ary($e), (tok = ($d[0] == null ? nil : $d[0])), (self.racc_val = ($d[1] == null ? nil : $d[1])), $e;
                  if ($truthy(tok)) {
                    self.racc_t = (function() {if ($truthy(($ret_or_2 = token_table['$[]'](tok)))) {
                      return $ret_or_2
                    } else {
                      return 1
                    }; return nil; })()
                  } else {
                    self.racc_t = 0
                  };
                  if ($truthy(self.yydebug)) {
                    self.$racc_read_token(self.racc_t, tok, self.racc_val)};
                  self.racc_read_next = false;}};
              i = $rb_plus(i, self.racc_t);
              if ($truthy((function() {if ($truthy(($ret_or_3 = (function() {if ($truthy(($ret_or_4 = $rb_ge(i, 0)))) {
                return (act = action_table['$[]'](i))
              } else {
                return $ret_or_4
              }; return nil; })()))) {
                return action_check['$[]'](i)['$=='](self.racc_state['$[]'](-1))
              } else {
                return $ret_or_3
              }; return nil; })())) {
              } else {
                act = action_default['$[]'](self.racc_state['$[]'](-1))
              };
            } else {
              act = action_default['$[]'](self.racc_state['$[]'](-1))
            };
            while ($truthy((act = self.$_racc_evalact(act, arg)))) {
              
            };
          }}, $$7.$$s = self, $$7.$$arity = 0, $$7));
      }, $Parser__racc_do_parse_rb$6.$$arity = 2);
      
      Opal.def(self, '$yyparse', $Parser_yyparse$8 = function $$yyparse(recv, mid) {
        var self = this;

        return self.$__send__($$($nesting, 'Racc_YY_Parse_Method'), recv, mid, self.$_racc_setup(), true)
      }, $Parser_yyparse$8.$$arity = 2);
      
      Opal.def(self, '$_racc_yyparse_rb', $Parser__racc_yyparse_rb$9 = function $$_racc_yyparse_rb(recv, mid, arg, c_debug) {
        var $a, $b, $$10, self = this, action_table = nil, action_check = nil, action_default = nil, action_pointer = nil, _ = nil, token_table = nil, act = nil, i = nil;

        
        $b = arg, $a = Opal.to_ary($b), (action_table = ($a[0] == null ? nil : $a[0])), (action_check = ($a[1] == null ? nil : $a[1])), (action_default = ($a[2] == null ? nil : $a[2])), (action_pointer = ($a[3] == null ? nil : $a[3])), (_ = ($a[4] == null ? nil : $a[4])), (_ = ($a[5] == null ? nil : $a[5])), (_ = ($a[6] == null ? nil : $a[6])), (_ = ($a[7] == null ? nil : $a[7])), (_ = ($a[8] == null ? nil : $a[8])), (_ = ($a[9] == null ? nil : $a[9])), (token_table = ($a[10] == null ? nil : $a[10])), (_ = ($a[11] == null ? nil : $a[11])), (_ = ($a[12] == null ? nil : $a[12])), (_ = ($a[13] == null ? nil : $a[13])), $b;
        self.$_racc_init_sysvars();
        act = nil;
        i = nil;
        return $send(self, 'catch', ["racc_end_parse"], ($$10 = function(){var self = $$10.$$s == null ? this : $$10.$$s, $c, $d, $$11;
          if (self.racc_state == null) self.racc_state = nil;

        
          while (!($truthy((i = action_pointer['$[]'](self.racc_state['$[]'](-1)))))) {
            while ($truthy((act = self.$_racc_evalact(action_default['$[]'](self.racc_state['$[]'](-1)), arg)))) {
              
            }
          };
          return $send(recv, '__send__', [mid], ($$11 = function(tok, val){var self = $$11.$$s == null ? this : $$11.$$s, $e, $f, $ret_or_5 = nil, $ret_or_6 = nil, $ret_or_7 = nil, $ret_or_8 = nil, $ret_or_9 = nil, $ret_or_10 = nil, $ret_or_11 = nil, $ret_or_12 = nil, $ret_or_13 = nil;
            if (self.racc_t == null) self.racc_t = nil;
            if (self.racc_state == null) self.racc_state = nil;
            if (self.racc_read_next == null) self.racc_read_next = nil;

          
            
            if (tok == null) {
              tok = nil;
            };
            
            if (val == null) {
              val = nil;
            };
            if ($truthy(tok)) {
              self.racc_t = (function() {if ($truthy(($ret_or_5 = token_table['$[]'](tok)))) {
                return $ret_or_5
              } else {
                return 1
              }; return nil; })()
            } else {
              self.racc_t = 0
            };
            self.racc_val = val;
            self.racc_read_next = false;
            i = $rb_plus(i, self.racc_t);
            if ($truthy((function() {if ($truthy(($ret_or_6 = (function() {if ($truthy(($ret_or_7 = $rb_ge(i, 0)))) {
              return (act = action_table['$[]'](i))
            } else {
              return $ret_or_7
            }; return nil; })()))) {
              return action_check['$[]'](i)['$=='](self.racc_state['$[]'](-1))
            } else {
              return $ret_or_6
            }; return nil; })())) {
            } else {
              act = action_default['$[]'](self.racc_state['$[]'](-1))
            };
            while ($truthy((act = self.$_racc_evalact(act, arg)))) {
              
            };
            while ($truthy((function() {if ($truthy(($ret_or_8 = (function() {if ($truthy(($ret_or_9 = (i = action_pointer['$[]'](self.racc_state['$[]'](-1)))['$!']()))) {
              return $ret_or_9
            } else {
              return self.racc_read_next['$!']()
            }; return nil; })()))) {
              return $ret_or_8
            } else {
              return self.racc_t['$=='](0)
            }; return nil; })())) {
              
              if ($truthy((function() {if ($truthy(($ret_or_10 = (function() {if ($truthy(($ret_or_11 = (function() {if ($truthy(($ret_or_12 = (function() {if ($truthy(($ret_or_13 = i))) {
                return (i = $rb_plus(i, self.racc_t))
              } else {
                return $ret_or_13
              }; return nil; })()))) {
                return $rb_ge(i, 0)
              } else {
                return $ret_or_12
              }; return nil; })()))) {
                return (act = action_table['$[]'](i))
              } else {
                return $ret_or_11
              }; return nil; })()))) {
                return action_check['$[]'](i)['$=='](self.racc_state['$[]'](-1))
              } else {
                return $ret_or_10
              }; return nil; })())) {
              } else {
                act = action_default['$[]'](self.racc_state['$[]'](-1))
              };
              while ($truthy((act = self.$_racc_evalact(act, arg)))) {
                
              };
            };}, $$11.$$s = self, $$11.$$arity = 2, $$11));}, $$10.$$s = self, $$10.$$arity = 0, $$10));
      }, $Parser__racc_yyparse_rb$9.$$arity = 4);
      
      Opal.def(self, '$_racc_evalact', $Parser__racc_evalact$12 = function $$_racc_evalact(act, arg) {
        var $a, $b, $$13, self = this, action_table = nil, action_check = nil, _ = nil, action_pointer = nil, shift_n = nil, reduce_n = nil, $ret_or_14 = nil, $ret_or_15 = nil, code = nil, $case = nil, i = nil, $ret_or_16 = nil, $ret_or_17 = nil;

        
        $b = arg, $a = Opal.to_ary($b), (action_table = ($a[0] == null ? nil : $a[0])), (action_check = ($a[1] == null ? nil : $a[1])), (_ = ($a[2] == null ? nil : $a[2])), (action_pointer = ($a[3] == null ? nil : $a[3])), (_ = ($a[4] == null ? nil : $a[4])), (_ = ($a[5] == null ? nil : $a[5])), (_ = ($a[6] == null ? nil : $a[6])), (_ = ($a[7] == null ? nil : $a[7])), (_ = ($a[8] == null ? nil : $a[8])), (_ = ($a[9] == null ? nil : $a[9])), (_ = ($a[10] == null ? nil : $a[10])), (shift_n = ($a[11] == null ? nil : $a[11])), (reduce_n = ($a[12] == null ? nil : $a[12])), (_ = ($a[13] == null ? nil : $a[13])), (_ = ($a[14] == null ? nil : $a[14])), $b;
        if ($truthy((function() {if ($truthy(($ret_or_14 = $rb_gt(act, 0)))) {
          return $rb_lt(act, shift_n)
        } else {
          return $ret_or_14
        }; return nil; })())) {
          
          if ($truthy($rb_gt(self.racc_error_status, 0))) {
            if (self.racc_t['$=='](1)) {
            } else {
              self.racc_error_status = $rb_minus(self.racc_error_status, 1)
            }};
          self.racc_vstack.$push(self.racc_val);
          self.racc_state.$push(act);
          self.racc_read_next = true;
          if ($truthy(self.yydebug)) {
            
            self.racc_tstack.$push(self.racc_t);
            self.$racc_shift(self.racc_t, self.racc_tstack, self.racc_vstack);};
        } else if ($truthy((function() {if ($truthy(($ret_or_15 = $rb_lt(act, 0)))) {
          return $rb_gt(act, reduce_n['$-@']())
        } else {
          return $ret_or_15
        }; return nil; })())) {
          
          code = $send(self, 'catch', ["racc_jump"], ($$13 = function(){var self = $$13.$$s == null ? this : $$13.$$s;
            if (self.racc_state == null) self.racc_state = nil;

          
            self.racc_state.$push(self.$_racc_do_reduce(arg, act));
            return false;}, $$13.$$s = self, $$13.$$arity = 0, $$13));
          if ($truthy(code)) {
            $case = code;
            if ((1)['$===']($case)) {
            self.racc_user_yyerror = true;
            return reduce_n['$-@']();}
            else if ((2)['$===']($case)) {return shift_n}
            else {self.$raise("[Racc Bug] unknown jump code")}};
        } else if (act['$=='](shift_n)) {
          
          if ($truthy(self.yydebug)) {
            self.$racc_accept()};
          self.$throw("racc_end_parse", self.racc_vstack['$[]'](0));
        } else if (act['$=='](reduce_n['$-@']())) {
          
          $case = self.racc_error_status;
          if ((0)['$===']($case)) {if ($truthy(arg['$[]'](21))) {
          } else {
            self.$on_error(self.racc_t, self.racc_val, self.racc_vstack)
          }}
          else if ((3)['$===']($case)) {
          if (self.racc_t['$=='](0)) {
            self.$throw("racc_end_parse", nil)};
          self.racc_read_next = true;};
          self.racc_user_yyerror = false;
          self.racc_error_status = 3;
          while ($truthy(true)) {
            
            if ($truthy((i = action_pointer['$[]'](self.racc_state['$[]'](-1))))) {
              
              i = $rb_plus(i, 1);
              if ($truthy((function() {if ($truthy(($ret_or_16 = (function() {if ($truthy(($ret_or_17 = $rb_ge(i, 0)))) {
                
                return (act = action_table['$[]'](i));
              } else {
                return $ret_or_17
              }; return nil; })()))) {
                return action_check['$[]'](i)['$=='](self.racc_state['$[]'](-1))
              } else {
                return $ret_or_16
              }; return nil; })())) {
                break;};};
            if ($truthy($rb_le(self.racc_state.$size(), 1))) {
              self.$throw("racc_end_parse", nil)};
            self.racc_state.$pop();
            self.racc_vstack.$pop();
            if ($truthy(self.yydebug)) {
              
              self.racc_tstack.$pop();
              self.$racc_e_pop(self.racc_state, self.racc_tstack, self.racc_vstack);};
          };
          return act;
        } else {
          self.$raise("" + "[Racc Bug] unknown action " + (act.$inspect()))
        };
        if ($truthy(self.yydebug)) {
          self.$racc_next_state(self.racc_state['$[]'](-1), self.racc_state)};
        return nil;
      }, $Parser__racc_evalact$12.$$arity = 2);
      
      Opal.def(self, '$_racc_do_reduce', $Parser__racc_do_reduce$14 = function $$_racc_do_reduce(arg, act) {
        var $a, $b, self = this, _ = nil, goto_table = nil, goto_check = nil, goto_default = nil, goto_pointer = nil, nt_base = nil, reduce_table = nil, use_result = nil, state = nil, vstack = nil, tstack = nil, i = nil, len = nil, reduce_to = nil, method_id = nil, void_array = nil, tmp_t = nil, tmp_v = nil, $writer = nil, k1 = nil, $ret_or_18 = nil, $ret_or_19 = nil, curstate = nil;

        
        $b = arg, $a = Opal.to_ary($b), (_ = ($a[0] == null ? nil : $a[0])), (_ = ($a[1] == null ? nil : $a[1])), (_ = ($a[2] == null ? nil : $a[2])), (_ = ($a[3] == null ? nil : $a[3])), (goto_table = ($a[4] == null ? nil : $a[4])), (goto_check = ($a[5] == null ? nil : $a[5])), (goto_default = ($a[6] == null ? nil : $a[6])), (goto_pointer = ($a[7] == null ? nil : $a[7])), (nt_base = ($a[8] == null ? nil : $a[8])), (reduce_table = ($a[9] == null ? nil : $a[9])), (_ = ($a[10] == null ? nil : $a[10])), (_ = ($a[11] == null ? nil : $a[11])), (_ = ($a[12] == null ? nil : $a[12])), (use_result = ($a[13] == null ? nil : $a[13])), $b;
        state = self.racc_state;
        vstack = self.racc_vstack;
        tstack = self.racc_tstack;
        i = $rb_times(act, -3);
        len = reduce_table['$[]'](i);
        reduce_to = reduce_table['$[]']($rb_plus(i, 1));
        method_id = reduce_table['$[]']($rb_plus(i, 2));
        void_array = [];
        if ($truthy(self.yydebug)) {
          tmp_t = tstack['$[]'](len['$-@'](), len)};
        tmp_v = vstack['$[]'](len['$-@'](), len);
        if ($truthy(self.yydebug)) {
          
          $writer = [len['$-@'](), len, void_array];
          $send(tstack, '[]=', Opal.to_a($writer));
          $writer[$rb_minus($writer["length"], 1)];};
        
        $writer = [len['$-@'](), len, void_array];
        $send(vstack, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        
        $writer = [len['$-@'](), len, void_array];
        $send(state, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        if ($truthy(use_result)) {
          vstack.$push(self.$__send__(method_id, tmp_v, vstack, tmp_v['$[]'](0)))
        } else {
          vstack.$push(self.$__send__(method_id, tmp_v, vstack))
        };
        tstack.$push(reduce_to);
        if ($truthy(self.yydebug)) {
          self.$racc_reduce(tmp_t, reduce_to, tstack, vstack)};
        k1 = $rb_minus(reduce_to, nt_base);
        if ($truthy((i = goto_pointer['$[]'](k1)))) {
          
          i = $rb_plus(i, state['$[]'](-1));
          if ($truthy((function() {if ($truthy(($ret_or_18 = (function() {if ($truthy(($ret_or_19 = $rb_ge(i, 0)))) {
            
            return (curstate = goto_table['$[]'](i));
          } else {
            return $ret_or_19
          }; return nil; })()))) {
            return goto_check['$[]'](i)['$=='](k1)
          } else {
            return $ret_or_18
          }; return nil; })())) {
            return curstate};};
        return goto_default['$[]'](k1);
      }, $Parser__racc_do_reduce$14.$$arity = 2);
      
      Opal.def(self, '$on_error', $Parser_on_error$15 = function $$on_error(t, val, vstack) {
        var self = this, $ret_or_20 = nil;

        return self.$raise($$($nesting, 'ParseError'), self.$sprintf("\nparse error on value %s (%s)", val.$inspect(), (function() {if ($truthy(($ret_or_20 = self.$token_to_str(t)))) {
          return $ret_or_20
        } else {
          return "?"
        }; return nil; })()))
      }, $Parser_on_error$15.$$arity = 3);
      
      Opal.def(self, '$yyerror', $Parser_yyerror$16 = function $$yyerror() {
        var self = this;

        return self.$throw("racc_jump", 1)
      }, $Parser_yyerror$16.$$arity = 0);
      
      Opal.def(self, '$yyaccept', $Parser_yyaccept$17 = function $$yyaccept() {
        var self = this;

        return self.$throw("racc_jump", 2)
      }, $Parser_yyaccept$17.$$arity = 0);
      
      Opal.def(self, '$yyerrok', $Parser_yyerrok$18 = function $$yyerrok() {
        var self = this;

        return (self.racc_error_status = 0)
      }, $Parser_yyerrok$18.$$arity = 0);
      
      Opal.def(self, '$racc_read_token', $Parser_racc_read_token$19 = function $$racc_read_token(t, tok, val) {
        var self = this;

        
        self.racc_debug_out.$print("read    ");
        self.racc_debug_out.$print(tok.$inspect(), "(", self.$racc_token2str(t), ") ");
        self.racc_debug_out.$puts(val.$inspect());
        return self.racc_debug_out.$puts();
      }, $Parser_racc_read_token$19.$$arity = 3);
      
      Opal.def(self, '$racc_shift', $Parser_racc_shift$20 = function $$racc_shift(tok, tstack, vstack) {
        var self = this;

        
        self.racc_debug_out.$puts("" + "shift   " + (self.$racc_token2str(tok)));
        self.$racc_print_stacks(tstack, vstack);
        return self.racc_debug_out.$puts();
      }, $Parser_racc_shift$20.$$arity = 3);
      
      Opal.def(self, '$racc_reduce', $Parser_racc_reduce$21 = function $$racc_reduce(toks, sim, tstack, vstack) {
        var $$22, self = this, out = nil;

        
        out = self.racc_debug_out;
        out.$print("reduce ");
        if ($truthy(toks['$empty?']())) {
          out.$print(" <none>")
        } else {
          $send(toks, 'each', [], ($$22 = function(t){var self = $$22.$$s == null ? this : $$22.$$s;

          
            
            if (t == null) {
              t = nil;
            };
            return out.$print(" ", self.$racc_token2str(t));}, $$22.$$s = self, $$22.$$arity = 1, $$22))
        };
        out.$puts("" + " --> " + (self.$racc_token2str(sim)));
        self.$racc_print_stacks(tstack, vstack);
        return self.racc_debug_out.$puts();
      }, $Parser_racc_reduce$21.$$arity = 4);
      
      Opal.def(self, '$racc_accept', $Parser_racc_accept$23 = function $$racc_accept() {
        var self = this;

        
        self.racc_debug_out.$puts("accept");
        return self.racc_debug_out.$puts();
      }, $Parser_racc_accept$23.$$arity = 0);
      
      Opal.def(self, '$racc_e_pop', $Parser_racc_e_pop$24 = function $$racc_e_pop(state, tstack, vstack) {
        var self = this;

        
        self.racc_debug_out.$puts("error recovering mode: pop token");
        self.$racc_print_states(state);
        self.$racc_print_stacks(tstack, vstack);
        return self.racc_debug_out.$puts();
      }, $Parser_racc_e_pop$24.$$arity = 3);
      
      Opal.def(self, '$racc_next_state', $Parser_racc_next_state$25 = function $$racc_next_state(curstate, state) {
        var self = this;

        
        self.racc_debug_out.$puts("" + "goto    " + (curstate));
        self.$racc_print_states(state);
        return self.racc_debug_out.$puts();
      }, $Parser_racc_next_state$25.$$arity = 2);
      
      Opal.def(self, '$racc_print_stacks', $Parser_racc_print_stacks$26 = function $$racc_print_stacks(t, v) {
        var $$27, self = this, out = nil;

        
        out = self.racc_debug_out;
        out.$print("        [");
        $send(t, 'each_index', [], ($$27 = function(i){var self = $$27.$$s == null ? this : $$27.$$s;

        
          
          if (i == null) {
            i = nil;
          };
          return out.$print(" (", self.$racc_token2str(t['$[]'](i)), " ", v['$[]'](i).$inspect(), ")");}, $$27.$$s = self, $$27.$$arity = 1, $$27));
        return out.$puts(" ]");
      }, $Parser_racc_print_stacks$26.$$arity = 2);
      
      Opal.def(self, '$racc_print_states', $Parser_racc_print_states$28 = function $$racc_print_states(s) {
        var $$29, self = this, out = nil;

        
        out = self.racc_debug_out;
        out.$print("        [");
        $send(s, 'each', [], ($$29 = function(st){var self = $$29.$$s == null ? this : $$29.$$s;

        
          
          if (st == null) {
            st = nil;
          };
          return out.$print(" ", st);}, $$29.$$s = self, $$29.$$arity = 1, $$29));
        return out.$puts(" ]");
      }, $Parser_racc_print_states$28.$$arity = 1);
      
      Opal.def(self, '$racc_token2str', $Parser_racc_token2str$30 = function $$racc_token2str(tok) {
        var self = this, $ret_or_21 = nil;

        if ($truthy(($ret_or_21 = $$$(self.$class(), 'Racc_token_to_s_table')['$[]'](tok)))) {
          return $ret_or_21
        } else {
          return self.$raise("" + "[Racc Bug] can't convert token " + (tok) + " to string")
        }
      }, $Parser_racc_token2str$30.$$arity = 1);
      return (Opal.def(self, '$token_to_str', $Parser_token_to_str$31 = function $$token_to_str(t) {
        var self = this;

        return $$$(self.$class(), 'Racc_token_to_s_table')['$[]'](t)
      }, $Parser_token_to_str$31.$$arity = 1), nil) && 'token_to_str';
    })($nesting[0], null, $nesting);
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["strscan"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $klass = Opal.klass, $truthy = Opal.truthy, $send = Opal.send;

  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'StringScanner');

    var $nesting = [self].concat($parent_nesting), $StringScanner_initialize$1, $StringScanner_beginning_of_line$ques$2, $StringScanner_scan$3, $StringScanner_scan_until$4, $StringScanner_$$$5, $StringScanner_check$6, $StringScanner_check_until$7, $StringScanner_peek$8, $StringScanner_eos$ques$9, $StringScanner_exist$ques$10, $StringScanner_skip$11, $StringScanner_skip_until$12, $StringScanner_get_byte$13, $StringScanner_match$ques$14, $StringScanner_pos$eq$15, $StringScanner_matched_size$16, $StringScanner_post_match$17, $StringScanner_pre_match$18, $StringScanner_reset$19, $StringScanner_rest$20, $StringScanner_rest$ques$21, $StringScanner_rest_size$22, $StringScanner_terminate$23, $StringScanner_unscan$24, $StringScanner_anchor$25;

    self.$$prototype.pos = self.$$prototype.string = self.$$prototype.working = self.$$prototype.matched = self.$$prototype.prev_pos = self.$$prototype.match = nil;
    
    self.$attr_reader("pos");
    self.$attr_reader("matched");
    
    Opal.def(self, '$initialize', $StringScanner_initialize$1 = function $$initialize(string) {
      var self = this;

      
      self.string = string;
      self.pos = 0;
      self.matched = nil;
      self.working = string;
      return (self.match = []);
    }, $StringScanner_initialize$1.$$arity = 1);
    self.$attr_reader("string");
    
    Opal.def(self, '$beginning_of_line?', $StringScanner_beginning_of_line$ques$2 = function() {
      var self = this;

      return self.pos === 0 || self.string.charAt(self.pos - 1) === "\n"
    }, $StringScanner_beginning_of_line$ques$2.$$arity = 0);
    Opal.alias(self, "bol?", "beginning_of_line?");
    
    Opal.def(self, '$scan', $StringScanner_scan$3 = function $$scan(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var result = pattern.exec(self.working);

      if (result == null) {
        return self.matched = nil;
      }
      else if (typeof(result) === 'object') {
        self.prev_pos = self.pos;
        self.pos     += result[0].length;
        self.working  = self.working.substring(result[0].length);
        self.matched  = result[0];
        self.match    = result;

        return result[0];
      }
      else if (typeof(result) === 'string') {
        self.pos     += result.length;
        self.working  = self.working.substring(result.length);

        return result;
      }
      else {
        return nil;
      }
    ;
    }, $StringScanner_scan$3.$$arity = 1);
    
    Opal.def(self, '$scan_until', $StringScanner_scan_until$4 = function $$scan_until(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var pos     = self.pos,
          working = self.working,
          result;

      while (true) {
        result   = pattern.exec(working);
        pos     += 1;
        working  = working.substr(1);

        if (result == null) {
          if (working.length === 0) {
            self.match = [];
            return self.matched = nil;
          }

          continue;
        }

        self.matched  = self.string.substr(self.pos, pos - self.pos - 1 + result[0].length);
        self.match    = result;
        self.prev_pos = pos - 1;
        self.pos      = pos;
        self.working  = working.substr(result[0].length);

        return self.matched;
      }
    ;
    }, $StringScanner_scan_until$4.$$arity = 1);
    
    Opal.def(self, '$[]', $StringScanner_$$$5 = function(idx) {
      var self = this, $case = nil;

      
      if ($truthy(self.match['$empty?']())) {
        return nil};
      $case = idx;
      if ($$($nesting, 'Symbol')['$===']($case)) {idx = idx.$to_s()}
      else if ($$($nesting, 'String')['$===']($case)) {nil}
      else {idx = $$($nesting, 'Opal')['$coerce_to!'](idx, $$($nesting, 'Integer'), "to_int")};
      
      var match = self.match;

      if (idx < 0) {
        idx += match.length;
      }

      if (idx < 0 || idx >= match.length) {
        return nil;
      }

      if (match[idx] == null) {
        return nil;
      }

      return match[idx];
    ;
    }, $StringScanner_$$$5.$$arity = 1);
    
    Opal.def(self, '$check', $StringScanner_check$6 = function $$check(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var result = pattern.exec(self.working);

      if (result == null) {
        return self.matched = nil;
      }

      return self.matched = result[0];
    ;
    }, $StringScanner_check$6.$$arity = 1);
    
    Opal.def(self, '$check_until', $StringScanner_check_until$7 = function $$check_until(pattern) {
      var self = this;

      
      var prev_pos = self.prev_pos,
          pos      = self.pos;

      var result = self.$scan_until(pattern);

      if (result !== nil) {
        self.matched = result.substr(-1);
        self.working = self.string.substr(pos);
      }

      self.prev_pos = prev_pos;
      self.pos      = pos;

      return result;
    
    }, $StringScanner_check_until$7.$$arity = 1);
    
    Opal.def(self, '$peek', $StringScanner_peek$8 = function $$peek(length) {
      var self = this;

      return self.working.substring(0, length)
    }, $StringScanner_peek$8.$$arity = 1);
    
    Opal.def(self, '$eos?', $StringScanner_eos$ques$9 = function() {
      var self = this;

      return self.working.length === 0
    }, $StringScanner_eos$ques$9.$$arity = 0);
    
    Opal.def(self, '$exist?', $StringScanner_exist$ques$10 = function(pattern) {
      var self = this;

      
      var result = pattern.exec(self.working);

      if (result == null) {
        return nil;
      }
      else if (result.index == 0) {
        return 0;
      }
      else {
        return result.index + 1;
      }
    
    }, $StringScanner_exist$ques$10.$$arity = 1);
    
    Opal.def(self, '$skip', $StringScanner_skip$11 = function $$skip(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var result = pattern.exec(self.working);

      if (result == null) {
        self.match = [];
        return self.matched = nil;
      }
      else {
        var match_str = result[0];
        var match_len = match_str.length;

        self.matched   = match_str;
        self.match     = result;
        self.prev_pos  = self.pos;
        self.pos      += match_len;
        self.working   = self.working.substring(match_len);

        return match_len;
      }
    ;
    }, $StringScanner_skip$11.$$arity = 1);
    
    Opal.def(self, '$skip_until', $StringScanner_skip_until$12 = function $$skip_until(pattern) {
      var self = this;

      
      var result = self.$scan_until(pattern);

      if (result === nil) {
        return nil;
      }
      else {
        self.matched = result.substr(-1);

        return result.length;
      }
    
    }, $StringScanner_skip_until$12.$$arity = 1);
    
    Opal.def(self, '$get_byte', $StringScanner_get_byte$13 = function $$get_byte() {
      var self = this;

      
      var result = nil;

      if (self.pos < self.string.length) {
        self.prev_pos  = self.pos;
        self.pos      += 1;
        result      = self.matched = self.working.substring(0, 1);
        self.working   = self.working.substring(1);
      }
      else {
        self.matched = nil;
      }

      return result;
    
    }, $StringScanner_get_byte$13.$$arity = 0);
    Opal.alias(self, "getch", "get_byte");
    
    Opal.def(self, '$match?', $StringScanner_match$ques$14 = function(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var result = pattern.exec(self.working);

      if (result == null) {
        return nil;
      }
      else {
        self.prev_pos = self.pos;

        return result[0].length;
      }
    ;
    }, $StringScanner_match$ques$14.$$arity = 1);
    
    Opal.def(self, '$pos=', $StringScanner_pos$eq$15 = function(pos) {
      var self = this;

      
      
      if (pos < 0) {
        pos += self.string.$length();
      }
    ;
      self.pos = pos;
      return (self.working = self.string.slice(pos));
    }, $StringScanner_pos$eq$15.$$arity = 1);
    
    Opal.def(self, '$matched_size', $StringScanner_matched_size$16 = function $$matched_size() {
      var self = this;

      
      if (self.matched === nil) {
        return nil;
      }

      return self.matched.length
    
    }, $StringScanner_matched_size$16.$$arity = 0);
    
    Opal.def(self, '$post_match', $StringScanner_post_match$17 = function $$post_match() {
      var self = this;

      
      if (self.matched === nil) {
        return nil;
      }

      return self.string.substr(self.pos);
    
    }, $StringScanner_post_match$17.$$arity = 0);
    
    Opal.def(self, '$pre_match', $StringScanner_pre_match$18 = function $$pre_match() {
      var self = this;

      
      if (self.matched === nil) {
        return nil;
      }

      return self.string.substr(0, self.prev_pos);
    
    }, $StringScanner_pre_match$18.$$arity = 0);
    
    Opal.def(self, '$reset', $StringScanner_reset$19 = function $$reset() {
      var self = this;

      
      self.working = self.string;
      self.matched = nil;
      return (self.pos = 0);
    }, $StringScanner_reset$19.$$arity = 0);
    
    Opal.def(self, '$rest', $StringScanner_rest$20 = function $$rest() {
      var self = this;

      return self.working
    }, $StringScanner_rest$20.$$arity = 0);
    
    Opal.def(self, '$rest?', $StringScanner_rest$ques$21 = function() {
      var self = this;

      return self.working.length !== 0
    }, $StringScanner_rest$ques$21.$$arity = 0);
    
    Opal.def(self, '$rest_size', $StringScanner_rest_size$22 = function $$rest_size() {
      var self = this;

      return self.$rest().$size()
    }, $StringScanner_rest_size$22.$$arity = 0);
    
    Opal.def(self, '$terminate', $StringScanner_terminate$23 = function $$terminate() {
      var self = this, $writer = nil;

      
      self.match = nil;
      
      $writer = [self.string.$length()];
      $send(self, 'pos=', Opal.to_a($writer));
      return $writer[$rb_minus($writer["length"], 1)];;
    }, $StringScanner_terminate$23.$$arity = 0);
    
    Opal.def(self, '$unscan', $StringScanner_unscan$24 = function $$unscan() {
      var self = this;

      
      self.pos = self.prev_pos;
      self.prev_pos = nil;
      self.match = nil;
      return self;
    }, $StringScanner_unscan$24.$$arity = 0);
    self.$private();
    return (Opal.def(self, '$anchor', $StringScanner_anchor$25 = function $$anchor(pattern) {
      var self = this;

      
      var flags = pattern.toString().match(/\/([^\/]+)$/);
      flags = flags ? flags[1] : undefined;
      return new RegExp('^(?:' + pattern.source + ')', flags);
    
    }, $StringScanner_anchor$25.$$arity = 1), nil) && 'anchor';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/normalize"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'Normalize');

      var $nesting = [self].concat($parent_nesting), $Normalize_comparison_operator$1, $Normalize_target_number$2;

      
      self.$module_function();
      
      Opal.def(self, '$comparison_operator', $Normalize_comparison_operator$1 = function $$comparison_operator(op) {
        var self = this, $case = nil;

        return (function() {$case = op;
        if (/<=|=</['$===']($case)) {return "<="}
        else if (/>=|=>/['$===']($case)) {return ">="}
        else if (/<>|!=|=!/['$===']($case)) {return "!="}
        else if (/</['$===']($case)) {return "<"}
        else if (/>/['$===']($case)) {return ">"}
        else if (/=/['$===']($case)) {return "=="}
        else { return nil }})()
      }, $Normalize_comparison_operator$1.$$arity = 1);
      
      Opal.def(self, '$target_number', $Normalize_target_number$2 = function $$target_number(val) {
        var self = this;

        if (val['$==']("?")) {
          return val
        } else {
          return val.$to_i()
        }
      }, $Normalize_target_number$2.$$arity = 1);
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/lexer"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash2 = Opal.hash2, $truthy = Opal.truthy;

  
  self.$require("strscan");
  self.$require("bcdice/normalize");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $super, $parent_nesting) {
        var self = $klass($base, $super, 'Lexer');

        var $nesting = [self].concat($parent_nesting), $Lexer_initialize$1, $Lexer_next_token$2, $Lexer_source$3;

        self.$$prototype.scanner = nil;
        
        Opal.const_set($nesting[0], 'SYMBOLS', $hash2(["+", "-", "*", "/", "(", ")", "[", "]", "?", "@"], {"+": "PLUS", "-": "MINUS", "*": "ASTERISK", "/": "SLASH", "(": "PARENL", ")": "PARENR", "[": "BRACKETL", "]": "BRACKETR", "?": "QUESTION", "@": "AT"}).$freeze());
        
        Opal.def(self, '$initialize', $Lexer_initialize$1 = function $$initialize(source) {
          var self = this, $ret_or_1 = nil;

          
          source = (function() {if ($truthy(($ret_or_1 = source.$split(" ", 2).$first()))) {
            return $ret_or_1
          } else {
            return ""
          }; return nil; })();
          return (self.scanner = $$($nesting, 'StringScanner').$new(source));
        }, $Lexer_initialize$1.$$arity = 1);
        
        Opal.def(self, '$next_token', $Lexer_next_token$2 = function $$next_token() {
          var self = this, number = nil, cmp_op = nil, char$ = nil, type = nil, $ret_or_2 = nil;

          
          if ($truthy(self.scanner['$eos?']())) {
            return [false, "$"]};
          if ($truthy((number = self.scanner.$scan(/\d+/)))) {
            return ["NUMBER", number.$to_i()]
          } else if ($truthy((cmp_op = self.scanner.$scan(/[<>!=]+/)))) {
            return ["CMP_OP", $$($nesting, 'Normalize').$comparison_operator(cmp_op)]
          } else {
            
            char$ = self.scanner.$getch().$upcase();
            type = (function() {if ($truthy(($ret_or_2 = $$($nesting, 'SYMBOLS')['$[]'](char$)))) {
              return $ret_or_2
            } else {
              return char$.$to_sym()
            }; return nil; })();
            return [type, char$];
          };
        }, $Lexer_next_token$2.$$arity = 0);
        return (Opal.def(self, '$source', $Lexer_source$3 = function $$source() {
          var self = this;

          return self.scanner.$string()
        }, $Lexer_source$3.$$arity = 0), nil) && 'source';
      })($nesting[0], null, $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/arithmetic/parser"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash = Opal.hash;

  
  self.$require("racc/parser.rb");
  self.$require("bcdice/common_command/lexer");
  self.$require("bcdice/arithmetic/node");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'Arithmetic');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $super, $parent_nesting) {
        var self = $klass($base, $super, 'Parser');

        var $nesting = [self].concat($parent_nesting), $Parser_parse$1, $Parser_parse$2, $Parser_next_token$3, $Parser__reduce_1$4, $Parser__reduce_2$5, $Parser__reduce_4$6, $Parser__reduce_5$7, $Parser__reduce_7$8, $Parser__reduce_8$9, $Parser__reduce_9$10, $Parser__reduce_10$11, $Parser__reduce_11$12, $Parser__reduce_12$13, $Parser__reduce_13$14, $Parser__reduce_15$15, $Parser__reduce_16$16, $Parser__reduce_none$17, racc_action_table = nil, racc_action_check = nil, racc_action_pointer = nil, racc_action_default = nil, racc_goto_table = nil, racc_goto_check = nil, racc_goto_pointer = nil, racc_goto_default = nil, racc_reduce_table = nil, racc_reduce_n = nil, racc_shift_n = nil, racc_token_table = nil, racc_nt_base = nil, racc_use_result_var = nil;

        self.$$prototype.lexer = nil;
        
        Opal.defs(self, '$parse', $Parser_parse$1 = function $$parse(source) {
          var self = this;

          return self.$new().$parse(source)
        }, $Parser_parse$1.$$arity = 1);
        
        Opal.def(self, '$parse', $Parser_parse$2 = function $$parse(source) {
          var self = this;

          try {
            
            self.lexer = $$$($$$($$($nesting, 'BCDice'), 'CommonCommand'), 'Lexer').$new(source);
            return self.$do_parse();
          } catch ($err) {
            if (Opal.rescue($err, [$$($nesting, 'ParseError')])) {
              try {
                return nil
              } finally { Opal.pop_exception() }
            } else { throw $err; }
          }
        }, $Parser_parse$2.$$arity = 1);
        self.$private();
        
        Opal.def(self, '$next_token', $Parser_next_token$3 = function $$next_token() {
          var self = this;

          return self.lexer.$next_token()
        }, $Parser_next_token$3.$$arity = 0);
        racc_action_table = [8, 17, 8, 12, 13, 4, 5, 4, 5, 7, 8, 7, 8, 12, 13, 4, 5, 4, 5, 7, 8, 7, 8, 12, 13, 4, 5, 4, 5, 7, 8, 7, 8, nil, nil, 4, 5, 4, 5, 7, 9, 7, nil, nil, 10, 11, nil, 10, 11, 22, 26, 24, 25, 27];
        racc_action_check = [0, 9, 4, 2, 2, 0, 0, 4, 4, 0, 5, 4, 7, 18, 18, 5, 5, 7, 7, 5, 10, 7, 11, 19, 19, 10, 10, 11, 11, 10, 12, 11, 13, nil, nil, 12, 12, 13, 13, 12, 1, 13, nil, nil, 16, 16, nil, 1, 1, 16, 21, 21, 21, 21];
        racc_action_pointer = [-2, 40, -6, nil, 0, 8, nil, 10, nil, 1, 18, 20, 28, 30, nil, nil, 37, nil, 4, 14, nil, 47, nil, nil, nil, nil, nil, nil];
        racc_action_default = [-17, -17, -3, -6, -17, -17, -14, -17, -16, -17, -17, -17, -17, -17, -12, -13, -17, 28, -1, -2, -4, -7, -15, -5, -8, -9, -10, -11];
        racc_goto_table = [14, 15, 23, 1, 18, 19, nil, nil, 20, 21, 16];
        racc_goto_check = [3, 3, 4, 1, 2, 2, nil, nil, 3, 3, 1];
        racc_goto_pointer = [nil, 3, -6, -4, -19, nil];
        racc_goto_default = [nil, nil, 2, 3, nil, 6];
        racc_reduce_table = [0, 0, "racc_error", 3, 14, "_reduce_1", 3, 14, "_reduce_2", 1, 14, "_reduce_none", 3, 15, "_reduce_4", 4, 15, "_reduce_5", 1, 15, "_reduce_none", 0, 17, "_reduce_7", 1, 17, "_reduce_8", 1, 17, "_reduce_9", 1, 17, "_reduce_10", 1, 17, "_reduce_11", 2, 16, "_reduce_12", 2, 16, "_reduce_13", 1, 16, "_reduce_none", 3, 18, "_reduce_15", 1, 18, "_reduce_16"];
        racc_reduce_n = 17;
        racc_shift_n = 28;
        racc_token_table = $hash(false, 0, "error", 1, "NUMBER", 2, "R", 3, "U", 4, "C", 5, "F", 6, "PLUS", 7, "MINUS", 8, "ASTERISK", 9, "SLASH", 10, "PARENL", 11, "PARENR", 12);
        racc_nt_base = 13;
        racc_use_result_var = true;
        Opal.const_set($nesting[0], 'Racc_arg', [racc_action_table, racc_action_check, racc_action_default, racc_action_pointer, racc_goto_table, racc_goto_check, racc_goto_default, racc_goto_pointer, racc_nt_base, racc_reduce_table, racc_token_table, racc_shift_n, racc_reduce_n, racc_use_result_var]);
        Opal.const_set($nesting[0], 'Racc_token_to_s_table', ["$end", "error", "NUMBER", "R", "U", "C", "F", "PLUS", "MINUS", "ASTERISK", "SLASH", "PARENL", "PARENR", "$start", "add", "mul", "unary", "round_type", "term"]);
        Opal.const_set($nesting[0], 'Racc_debug_parser', false);
        
        Opal.def(self, '$_reduce_1', $Parser__reduce_1$4 = function $$_reduce_1(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "+", val['$[]'](2));
          return result;
        }, $Parser__reduce_1$4.$$arity = 3);
        
        Opal.def(self, '$_reduce_2', $Parser__reduce_2$5 = function $$_reduce_2(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "-", val['$[]'](2));
          return result;
        }, $Parser__reduce_2$5.$$arity = 3);
        
        Opal.def(self, '$_reduce_4', $Parser__reduce_4$6 = function $$_reduce_4(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "*", val['$[]'](2));
          return result;
        }, $Parser__reduce_4$6.$$arity = 3);
        
        Opal.def(self, '$_reduce_5', $Parser__reduce_5$7 = function $$_reduce_5(val, _values, result) {
          var self = this, divied_class = nil;

          
          divied_class = val['$[]'](3);
          result = divied_class.$new(val['$[]'](0), val['$[]'](2));
          return result;
        }, $Parser__reduce_5$7.$$arity = 3);
        
        Opal.def(self, '$_reduce_7', $Parser__reduce_7$8 = function $$_reduce_7(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithGameSystemDefault');
          return result;
        }, $Parser__reduce_7$8.$$arity = 3);
        
        Opal.def(self, '$_reduce_8', $Parser__reduce_8$9 = function $$_reduce_8(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
          return result;
        }, $Parser__reduce_8$9.$$arity = 3);
        
        Opal.def(self, '$_reduce_9', $Parser__reduce_9$10 = function $$_reduce_9(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
          return result;
        }, $Parser__reduce_9$10.$$arity = 3);
        
        Opal.def(self, '$_reduce_10', $Parser__reduce_10$11 = function $$_reduce_10(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithRound');
          return result;
        }, $Parser__reduce_10$11.$$arity = 3);
        
        Opal.def(self, '$_reduce_11', $Parser__reduce_11$12 = function $$_reduce_11(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithFloor');
          return result;
        }, $Parser__reduce_11$12.$$arity = 3);
        
        Opal.def(self, '$_reduce_12', $Parser__reduce_12$13 = function $$_reduce_12(val, _values, result) {
          var self = this;

          
          result = val['$[]'](1);
          return result;
        }, $Parser__reduce_12$13.$$arity = 3);
        
        Opal.def(self, '$_reduce_13', $Parser__reduce_13$14 = function $$_reduce_13(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Negative').$new(val['$[]'](1));
          return result;
        }, $Parser__reduce_13$14.$$arity = 3);
        
        Opal.def(self, '$_reduce_15', $Parser__reduce_15$15 = function $$_reduce_15(val, _values, result) {
          var self = this;

          
          result = val['$[]'](1);
          return result;
        }, $Parser__reduce_15$15.$$arity = 3);
        
        Opal.def(self, '$_reduce_16', $Parser__reduce_16$16 = function $$_reduce_16(val, _values, result) {
          var self = this;

          
          result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Number').$new(val['$[]'](0));
          return result;
        }, $Parser__reduce_16$16.$$arity = 3);
        return (Opal.def(self, '$_reduce_none', $Parser__reduce_none$17 = function $$_reduce_none(val, _values, result) {
          var self = this;

          return val['$[]'](0)
        }, $Parser__reduce_none$17.$$arity = 3), nil) && '_reduce_none';
      })($nesting[0], $$$($$($nesting, 'Racc'), 'Parser'), $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/arithmetic"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $send = Opal.send;

  
  self.$require("bcdice/arithmetic/node");
  self.$require("bcdice/arithmetic/parser");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'Arithmetic');

      var $nesting = [self].concat($parent_nesting);

      (function(self, $parent_nesting) {
        var $nesting = [self].concat($parent_nesting), $eval$1;

        return (Opal.def(self, '$eval', $eval$1 = function(source, round_type) {
          var $a, self = this, node = nil;

          try {
            
            node = $$($nesting, 'Parser').$parse(source);
            return ($a = node, ($a === nil || $a == null) ? nil : $send($a, 'eval', [round_type]));
          } catch ($err) {
            if (Opal.rescue($err, [$$($nesting, 'ZeroDivisionError')])) {
              try {
                return nil
              } finally { Opal.pop_exception() }
            } else { throw $err; }
          }
        }, $eval$1.$$arity = 2), nil) && 'eval'
      })(Opal.get_singleton_class(self), $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
(function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy;

  
  self.$require("bcdice/arithmetic");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $super, $parent_nesting) {
      var self = $klass($base, $super, 'Preprocessor');

      var $nesting = [self].concat($parent_nesting), $Preprocessor_process$1, $Preprocessor_initialize$2, $Preprocessor_process$3, $Preprocessor_trim_after_whitespace$4, $Preprocessor_replace_parentheses$5, $Preprocessor_replace_implicit_d$8;

      self.$$prototype.game_system = self.$$prototype.text = nil;
      
      Opal.defs(self, '$process', $Preprocessor_process$1 = function $$process(text, game_system) {
        var self = this;

        return $$($nesting, 'Preprocessor').$new(text, game_system).$process()
      }, $Preprocessor_process$1.$$arity = 2);
      
      Opal.def(self, '$initialize', $Preprocessor_initialize$2 = function $$initialize(text, game_system) {
        var self = this;

        
        self.text = text;
        return (self.game_system = game_system);
      }, $Preprocessor_initialize$2.$$arity = 2);
      
      Opal.def(self, '$process', $Preprocessor_process$3 = function $$process() {
        var self = this;

        
        self.$trim_after_whitespace();
        self.$replace_parentheses();
        self.text = self.game_system.$change_text(self.text);
        self.$replace_implicit_d();
        return self.text;
      }, $Preprocessor_process$3.$$arity = 0);
      self.$private();
      
      Opal.def(self, '$trim_after_whitespace', $Preprocessor_trim_after_whitespace$4 = function $$trim_after_whitespace() {
        var self = this;

        return (self.text = self.text.$strip().$split(/\s/, 2).$first())
      }, $Preprocessor_trim_after_whitespace$4.$$arity = 0);
      
      Opal.def(self, '$replace_parentheses', $Preprocessor_replace_parentheses$5 = function $$replace_parentheses() {
        var $$6, self = this;

        return (function(){var $brk = Opal.new_brk(); try {return $send(self, 'loop', [], ($$6 = function(){var self = $$6.$$s == null ? this : $$6.$$s, $$7, prev = nil;
          if (self.text == null) self.text = nil;

        
          prev = self.text;
          self.text = $send(self.text, 'gsub', [/\([\d\/+*\-CURF]+\)/], ($$7 = function(expr){var self = $$7.$$s == null ? this : $$7.$$s, $ret_or_1 = nil;
            if (self.game_system == null) self.game_system = nil;

          
            
            if (expr == null) {
              expr = nil;
            };
            if ($truthy(($ret_or_1 = $$($nesting, 'Arithmetic').$eval(expr, self.game_system.$round_type())))) {
              return $ret_or_1
            } else {
              return expr
            };}, $$7.$$s = self, $$7.$$arity = 1, $$7));
          if (prev['$=='](self.text)) {
            
            Opal.brk(nil, $brk)
          } else {
            return nil
          };}, $$6.$$s = self, $$6.$$brk = $brk, $$6.$$arity = 0, $$6))
        } catch (err) { if (err === $brk) { return err.$v } else { throw err } }})()
      }, $Preprocessor_replace_parentheses$5.$$arity = 0);
      return (Opal.def(self, '$replace_implicit_d', $Preprocessor_replace_implicit_d$8 = function $$replace_implicit_d() {
        var $$9, self = this;

        return (self.text = $send(self.text, 'gsub', [/(\d+)D([^\w]|$)/i], ($$9 = function(){var self = $$9.$$s == null ? this : $$9.$$s, times = nil, sides = nil, trailer = nil;
          if (self.game_system == null) self.game_system = nil;

        
          times = $$($nesting, 'Regexp').$last_match(1);
          sides = self.game_system.$sides_implicit_d();
          trailer = $$($nesting, 'Regexp').$last_match(2);
          return "" + (times) + "D" + (sides) + (trailer);}, $$9.$$s = self, $$9.$$arity = 0, $$9)))
      }, $Preprocessor_replace_implicit_d$8.$$arity = 0), nil) && 'replace_implicit_d';
    })($nesting[0], null, $nesting)
  })($nesting[0], $nesting);
})(Opal);
